import { Subscription } from "rxjs";
import { complete$, modal$, subtotal$ } from "../lib/state";
import { money } from "../lib/util.functions";

class SubtotalBar extends HTMLElement {
  #abortController: AbortController | null = null;
  #subs: Subscription[] = [];
  #price: HTMLElement;
  #subtotalBtn: HTMLButtonElement;
  #themeBtn: HTMLButtonElement;
  #href: string = '';
  #type: 'preview' | 'review' = 'preview';

  constructor() {
    super();
    this.#price = this.querySelector('[data-price]') as HTMLElement;
    this.#subtotalBtn = this.querySelector('button[data-info]') as HTMLButtonElement;
    this.#themeBtn = this.querySelector('button.theme-button') as HTMLButtonElement;
  }

  connectedCallback(): void {
    this.#abortController = new AbortController();
    const { signal } = this.#abortController;
    //
    this.#subtotalBtn.addEventListener('click', () => modal$.next({ contentType: 'pricing', show: true }), { signal });
    this.#themeBtn.addEventListener('click', () => this.#onThemeBtn(), { signal });
    this.#themeBtn.parentElement?.addEventListener('click', () => this.#onThemeBtnParent(), { signal });
    //
    this.#subs = [
      subtotal$.subscribe((val) => {
        this.#price.textContent = money(val);
      })
    ];
    //
    if (this.#type === 'preview') {
      this.#subs.push(
        complete$.subscribe((val) => {
          if (this.#themeBtn.disabled !== !val) {
            this.#themeBtn.disabled = !val;
            if (val && this.offsetHeight) {
              setTimeout(() => {
                window.scrollTo({ top: this.offsetTop + this.offsetHeight - window.innerHeight + 6, behavior: 'smooth'});
              }, 500);
            }
          }
        })
      );
    }
  }

  disconnectedCallback(): void {
    this.#abortController?.abort();
    this.#abortController = null;
    this.#subs.forEach(sub => sub.unsubscribe());
  }

  static get observedAttributes(): string[] {
    return ['data-type'];
  }

  attributeChangedCallback(name: string, oldValue: string, newValue: string): void {
    if (name === 'data-type' && (newValue === 'preview' || newValue === 'review')) {
      this.#type = newValue;
      this.#href = this.#type === 'preview' ? '/pages/custom-tray-preview' : '/pages/custom-tray-review';
    }
  }

  #onThemeBtn() {
    window.location.href = this.#href;
  }

  #onThemeBtnParent() {
    if (this.#themeBtn.disabled) {
      (document.querySelector('.custom-tray-builder__transform-btn[data-type="fillgaps"]') as HTMLButtonElement)?.click();
    }
  }
}

customElements.define('subtotal-bar', SubtotalBar);